// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
    width: 100%;
    max-width: 600px;
    margin: auto;
    border: 1px solid #ddd;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
}

.chat-container .chat-header {
    display: flex;
    justify-content: space-between;
    padding: 20px;
}

.chat-container .chat-header .title {
    font-weight: 700;
    font-size: 16px;
    color: #000000;
    line-height: 27px;
    font-family: "Inter", sans-serif;
    text-align: left;
    letter-spacing: 0;
}

.chat-container .chat-header .close-icon img {
    width: 24px;
    height: 24px;
}

.chat-messages {
    padding: 5px 17px;
    overflow-y: auto;
    flex-grow: 1;
}

.chat-bubble {
    padding: 10px 0px;
    /* margin-bottom: 15px; */
    border-radius: 10px;
    max-width: 80%;
    word-wrap: break-word;
}

/* .manager-bubble {
   background-color: #38BBF4;
    text-align: left;
} */

.manager-bubble .msg {
    font-weight: 500;
    font-size: 12px;
    color: #ffffff;
    line-height: 19px;
    background-color: #38bbf4;
    text-align: left;
    border-radius: 10px 10px 10px 0px;
    padding: 11px 20px;
    margin-bottom: 0;
}

.user-bubble .msg {
    border-radius: 10px 10px 0px 10px;
    padding: 11px 20px;
    border: 1px solid #eeeeee;
    font-size: 12px;
    font-weight: 500;
    line-height: 19px;
    letter-spacing: -0.02em;
    text-align: left;
    color: #242424;
}

.user-bubble {
    /* background-color: transparent;
    border: 1px solid #EEEEEE;
    border-radius: 12px; */
    text-align: right;
    margin-left: auto;
}

.chat-info {
    display: flex;
    align-items: center;
    margin-top: 5px;
}

.chat-info span {
    color: #000000;
    font-weight: 400;
    font-size: 12px;
    line-height: 27px;
}

.sender-name {
    margin-left: 10px;
    font-size: 14px;
    color: #555;
}

.avatar {
    width: 30px;
    height: 30px;
    border-radius: 50%;
}

.attachment {
    display: flex;
    align-items: center;
    margin-top: 10px;
    justify-content: space-between;
    background-color: transparent;
    border: 1px solid #eeeeee;
    border-radius: 12px;
    padding: 10px 20px 10px 14px;
}

.attachment-link {
    margin-right: 10px;
    text-decoration: none;
    color: #000000;
    font-size: 12px;
    font-weight: 500;
    line-height: 27px;
}

.attachment-link:hover {
    text-decoration: none !important;
    color: #000000;
}

.file-icon {
    margin-right: 5px;
}

.download-icon {
    cursor: pointer;
    font-size: 12px;
    color: #888;
}

.chat-input {
    display: flex;
    align-items: center;
    border-top: 1px solid #ddd;
    padding: 10px;
    background-color: #f9f9f9;
}

.chat-input input {
    width: 100%;
    border: none;
    border-radius: 5px;
    margin-right: 10px;
}

.chat-input input::placeholder {
    color: #000000;
    font-size: 14px;
    font-weight: 400;
    line-height: 27px;
}

.chat-input .input-box-wrap {
    display: flex;
    background-color: #ffffff;
    align-items: center;
    width: 100%;
    padding: 13px 20px 15px 12px;
}

.chat-input .input-box-wrap .attach-file img {
    width: 24px;
    height: 24px;
}

.chat-input .send-btn {
    background-color: #06efc5;
    border: none;
    color: white;
    padding: 13px;
    cursor: pointer;
}

@media (max-width: 768px) {
    .chat-container {
        max-width: 100%;
    }

    .chat-bubble {
        max-width: 100%;
    }

    .chat-input input {
        padding: 8px;
    }

    .chat-input .send-btn {
        padding: 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/ChatMessages/ChatMessages.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,uCAAuC;IACvC,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gCAAgC;IAChC,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;GAGG;;AAEH;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,iCAAiC;IACjC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;;0BAEsB;IACtB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;IAC9B,6BAA6B;IAC7B,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".chat-container {\n    width: 100%;\n    max-width: 600px;\n    margin: auto;\n    border: 1px solid #ddd;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    display: flex;\n    flex-direction: column;\n}\n\n.chat-container .chat-header {\n    display: flex;\n    justify-content: space-between;\n    padding: 20px;\n}\n\n.chat-container .chat-header .title {\n    font-weight: 700;\n    font-size: 16px;\n    color: #000000;\n    line-height: 27px;\n    font-family: \"Inter\", sans-serif;\n    text-align: left;\n    letter-spacing: 0;\n}\n\n.chat-container .chat-header .close-icon img {\n    width: 24px;\n    height: 24px;\n}\n\n.chat-messages {\n    padding: 5px 17px;\n    overflow-y: auto;\n    flex-grow: 1;\n}\n\n.chat-bubble {\n    padding: 10px 0px;\n    /* margin-bottom: 15px; */\n    border-radius: 10px;\n    max-width: 80%;\n    word-wrap: break-word;\n}\n\n/* .manager-bubble {\n   background-color: #38BBF4;\n    text-align: left;\n} */\n\n.manager-bubble .msg {\n    font-weight: 500;\n    font-size: 12px;\n    color: #ffffff;\n    line-height: 19px;\n    background-color: #38bbf4;\n    text-align: left;\n    border-radius: 10px 10px 10px 0px;\n    padding: 11px 20px;\n    margin-bottom: 0;\n}\n\n.user-bubble .msg {\n    border-radius: 10px 10px 0px 10px;\n    padding: 11px 20px;\n    border: 1px solid #eeeeee;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 19px;\n    letter-spacing: -0.02em;\n    text-align: left;\n    color: #242424;\n}\n\n.user-bubble {\n    /* background-color: transparent;\n    border: 1px solid #EEEEEE;\n    border-radius: 12px; */\n    text-align: right;\n    margin-left: auto;\n}\n\n.chat-info {\n    display: flex;\n    align-items: center;\n    margin-top: 5px;\n}\n\n.chat-info span {\n    color: #000000;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 27px;\n}\n\n.sender-name {\n    margin-left: 10px;\n    font-size: 14px;\n    color: #555;\n}\n\n.avatar {\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n}\n\n.attachment {\n    display: flex;\n    align-items: center;\n    margin-top: 10px;\n    justify-content: space-between;\n    background-color: transparent;\n    border: 1px solid #eeeeee;\n    border-radius: 12px;\n    padding: 10px 20px 10px 14px;\n}\n\n.attachment-link {\n    margin-right: 10px;\n    text-decoration: none;\n    color: #000000;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 27px;\n}\n\n.attachment-link:hover {\n    text-decoration: none !important;\n    color: #000000;\n}\n\n.file-icon {\n    margin-right: 5px;\n}\n\n.download-icon {\n    cursor: pointer;\n    font-size: 12px;\n    color: #888;\n}\n\n.chat-input {\n    display: flex;\n    align-items: center;\n    border-top: 1px solid #ddd;\n    padding: 10px;\n    background-color: #f9f9f9;\n}\n\n.chat-input input {\n    width: 100%;\n    border: none;\n    border-radius: 5px;\n    margin-right: 10px;\n}\n\n.chat-input input::placeholder {\n    color: #000000;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 27px;\n}\n\n.chat-input .input-box-wrap {\n    display: flex;\n    background-color: #ffffff;\n    align-items: center;\n    width: 100%;\n    padding: 13px 20px 15px 12px;\n}\n\n.chat-input .input-box-wrap .attach-file img {\n    width: 24px;\n    height: 24px;\n}\n\n.chat-input .send-btn {\n    background-color: #06efc5;\n    border: none;\n    color: white;\n    padding: 13px;\n    cursor: pointer;\n}\n\n@media (max-width: 768px) {\n    .chat-container {\n        max-width: 100%;\n    }\n\n    .chat-bubble {\n        max-width: 100%;\n    }\n\n    .chat-input input {\n        padding: 8px;\n    }\n\n    .chat-input .send-btn {\n        padding: 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
